import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import { Box, Tooltip } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';

const useStyles = makeStyles({
  tooltip: {
    '&&': {
      borderRadius: '8px 0px 8px 8px',
      backgroundColor: '#0091B3',
      color: '#FFFFFF',
      fontSize: 14,
      maxWidth: 526,
      fontFamily: 'Roboto',
      fontWeight: 400,
      padding: 0,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
  },
});

interface AuthplusPendingTooltipProps {
  data?: string;
}

const AuthplusPendingTooltip: FC<AuthplusPendingTooltipProps> = ({ data }) => {
  const classes = useStyles();

  const convertPendingConstant = (status?: string) => {
    return status === 'PENDING_DOMAIN_VERIFICATION'
      ? 'Pending - Domain Verification'
      : 'Pending - 2FA Verification';
  };

  return (
    <div>
      <Tooltip
        classes={{ tooltip: classes.tooltip }}
        placement={'bottom-end'}
        style={{ color: '#49535D' }}
        title={
          <div
            className="vetting-details-authplus-tooltip"
            data-testid="vettingDetailsAuthplusTooltipContainer"
          >
            <div className="status">{convertPendingConstant(data)}</div>
          </div>
        }
      >
        <span data-testid="brandVettingDetailsBlockViewAuthplusStatus">
          <Box
            style={{
              marginTop: '3px',
              marginLeft: '3px',
              cursor: 'default',
            }}
          >
            <FontAwesomeIcon icon={faEye} />
          </Box>
        </span>
      </Tooltip>
    </div>
  );
};

export default AuthplusPendingTooltip;
